import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { SimpleCheckbox } from '@AMIEWEB/Unit/Common/SimpleCheckbox';
import moment from 'moment';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';

const useStyles = makeStyles()(theme => ({ 
  inputFields: {
    minWidth: '320px',
    maxWidth: '320px',
    '& .MuiFormHelperText-root': {
      width: 'max-content !important',
    },
  },
  checkbox: {
    '& label': {
      '& .MuiButtonBase-root.MuiCheckbox-root.Mui-checked': {
        color: `${theme.palette.system.main} !important`,
      },
      '&:hover .MuiButtonBase-root.MuiCheckbox-root': {
        color: `${theme.palette.system.main} !important`,
      },
    },
  },
}));

export const StrikeContainer = () => {
  const { t } = useTranslation();
  const { control, formState: { errors }, setValue } = useFormContext();
  const value: string = useWatch({ name: 'orderStrike.strikeNoticeDate' });
  const { classes } = useStyles();  
  
  return (
    <Grid container columnSpacing={2} marginTop={0} height={'123px'}>
      <Grid item xs={7}>
        <Controller
          control={control}
          name={'orderStrike.strikeNoticeDate'}
          render={({ field }) => {
            const strikeNoticeDate = moment(value ?? null);
            return (
              <React.Fragment>
                <DateRangePicker
                  onChange={newValue => {
                    if (newValue?.endDate !== undefined) {
                      const newDate = moment(newValue?.endDate);
                      const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                      field.onChange(setTo);
                    } else {
                      field.onChange(null);
                    }
                  }}
                  value={value}
                  onCancel={() => { }}
                  clear
                  open={false}
                  variant="filled"
                  single
                  placeholder={t('order.newOrderCreation.orderDetails.strikeDetails.strikeNoticeDate')}
                  labelClass={classes.inputFields}
                  className={classes.inputFields}
                  quickSelect={false}
                  textFieldSize='medium'
                  showIcon={true}
                  actionBar={false}
                  clickAway={true}
                  trailingIconShow={true}
                  keepClickAwayVal={true}
                  initialDateRange={{
                    startDate: strikeNoticeDate.isValid()
                      ? new Date(strikeNoticeDate.format('YYYY-MM-DDTHH:mm:ss'))
                      : undefined,
                    endDate: strikeNoticeDate.isValid()
                      ? new Date(strikeNoticeDate.format('YYYY-MM-DDTHH:mm:ss'))
                      : undefined,
                    useLabelAsValue: true,
                  }}
                  error={!isNullOrUndefined(errors?.strikeNoticeDate)}
                  helperText={
                    !isNullOrUndefined(errors?.strikeNoticeDate) ? errors?.strikeNoticeDate?.message : undefined
                  }
                />
              </React.Fragment>
            );
          }}
        />
      </Grid>
      <Grid item xs={5} columnSpacing={2}>
        <Grid item className={classes.checkbox} style={{ paddingTop: "12px", paddingLeft: "12px" }}>
          <Controller
            name={'orderStrike.okToTravel'}
            control={control}
            render={({ field}) => (
              <SimpleCheckbox
                defaultValue={field.value}
                isChecked={field.value || false}
                handleChecked={event => {
                  field.onChange(event.target.checked);
                  if (!event.target.checked) {
                    setValue('orderStrike.okToTravel', 0, { shouldValidate: true });
                  }
                }}
                checkboxLabel={t('order.newOrderCreation.orderDetails.strikeDetails.okToTravel')}
                checkboxName={'orderStrike.okToTravel'}
                id={'orderStrike.okToTravel'}
              />
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
